import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Spacing, Palette } from '@/shared/theme';

interface TipBoxProps {
  children: ReactNode;
  width?: string;
  icon?: string;
}

interface ContainerProps {
  width?: string;
}

const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  background-color: ${Palette.nearWhite};
  border-radius: ${Spacing.x1}px;
  padding: ${Spacing.x2}px;
  width: ${props => props.width || '100%'};
  box-sizing: border-box;
`;

const Icon = styled.img`
  width: 32px;
  height: 32px;
  margin-right: ${Spacing.x1}px;
  flex-shrink: 0;
`;

const Content = styled.div`
  flex: 1;
`;

export const TipBox: React.FC<TipBoxProps> = ({ children, width, icon }) => (
  <Container width={width}>
    {icon && <Icon src={icon} alt="" aria-hidden="true" />}
    <Content>{children}</Content>
  </Container>
);
